import { ActionBar } from 'components/actionBar';
import { ActionBarProps } from 'components/actionBar/ActionBar';
import { SlotCardType } from 'components/cards/slotCard';
import { GameDetail, GameDetailType } from 'components/gameDetail';
import { GameDetailSkillGamesCard, GameDetailSkillGamesCardType } from 'components/gameDetail/gameDetailSkillGamesCard';
import { GameDetailSkillGamesInfo, GameDetailSkillGamesInfoType } from 'components/gameDetail/gameDetailSkillGamesInfo';
import { GoBackGameDetail } from 'components/goBackGameDetail/GoBackGameDetail';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { NextPage } from 'next';
import { withRouter } from 'next/router';
import React from 'react';
import { Category } from 'types/categoryEnum';

type Props = {
  slot: ActionBarProps & GameDetailType & GameDetailSkillGamesCardType & GameDetailSkillGamesInfoType;
  choseFromSnaiCardsSearch: Array<SlotCardType>;
};

const PageContent: NextPage<Props> = ({ slot, choseFromSnaiCardsSearch }) => {
  const labelSlot = useGetLabelByKey('slot')!;

  return (
    <React.Fragment>
      <GoBackGameDetail title={'slot'} category={Category.Slot} cardChoseFromSnaiSlot={choseFromSnaiCardsSearch} />
      <ActionBar
        title={labelSlot}
        hasDemo={slot.hasDemo}
        playInfo={slot.playInfo}
        modalita={slot.modalita}
        provider={slot.specs?.find((spec) => spec.label === 'produttore')?.values?.[0]}
        gameMode={slot.specs?.find((spec) => spec.label === 'gamemode')?.values?.[0]}
        isInstant={slot.isInstant}
        launchType={slot.launchType}
        idProduttore={slot.idProduttore}
        titleHighlighted={slot.title}
        codicePiattaforma={slot.codicePiattaforma}
      />
      <GameDetail
        detailCardComponent={
          <GameDetailSkillGamesCard coverImage={slot.coverImage} isNew={slot.isNew} isExclusive={slot.isExclusive} />
        }
        detailInfoComponent={<GameDetailSkillGamesInfo promo={slot.promo} />}
        description={slot.description}
        coverImageCaption={slot.coverImageCaption}
        specs={slot.specs}
      />
    </React.Fragment>
  );
};

export default PageContent;
